<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-calendar"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">توقيت بداية الحجز</h1>
        <p class="form-page-header__subtitle">تحديد التاريخ والوقت الذي يفتح فيه باب التسجيل</p>
      </div>
    </div>

    <div class="container-fluid">
      <form @submit.prevent="sendForm()">
        <div class="notice-box mb-4">
          <i class="pi pi-info-circle"></i>
          <span>حدد التاريخ والوقت الذي سيبدأ فيه الموقع قبول طلبات الحجز الجديدة. بعد هذا الموعد يستطيع الطلاب التسجيل.</span>
        </div>

        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-clock"></i></div>
            <span class="form-card__title">تاريخ ووقت البداية</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-5 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">التاريخ</label>
                  <DatePicker v-model="date" showIcon fluid iconDisplay="input" :minDate="nowDate" class="w-100" />
                </div>
              </div>
              <div class="col-lg-5 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label">الوقت</label>
                  <DatePicker v-model="time" showIcon fluid iconDisplay="input" hourFormat="12" timeOnly class="w-100">
                    <template #inputicon="slotProps">
                      <i class="pi pi-clock" @click="slotProps.clickCallback" />
                    </template>
                  </DatePicker>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit">
            <i class="pi pi-check"></i>
            تحديث الوقت
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import DatePicker from 'primevue/datepicker';
import Breadcrumb from '@/components/global/breadcrumb.vue';

export default {
    name: "home-page",
    data() {
        return {
            date: '',
            time: '',
            nowDate: new Date(),
            breadcrumbs: [
                { name: 'الرئيسية', path: '/' },
                { name: 'بداية الحجز', path: '/website_time' },
            ]
        };
    },
    components: {
        DatePicker,
        Breadcrumb
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const month = '' + (d.getMonth() + 1);
            const day = '' + d.getDate();
            const year = d.getFullYear();
            return [
                year,
                month.padStart(2, '0'),
                day.padStart(2, '0')
            ].join('-');
        },
        formatTime(time) {
            if (!time) return '';
            const d = new Date(time);
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            const seconds = '00';
            return `${hours}:${minutes}:${seconds}`;
        },
        sendForm() {
            const formData = new FormData();
            formData.append('date', this.formatDate(this.date));
            formData.append('time', this.formatTime(this.time));

            axios
                .post('/set_website_start', formData)
                .then((response) => {
                    if (response.data.status == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم تحديث وقت الموقع بنجاح",
                        });
                    }
                    else {
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "حدث خطأ أثناء تحديث وقت الموقع",
                        });
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.response.data.message,
                    });
                });
        },
        fetchWebTime() {
            axios
                .get('/get_website_start')
                .then((response) => {
                    this.date = response.data.website_start.date;
                    // Combine date and time to create a Date object
                    const dateStr = response.data.website_start.date; // "2025-06-21"
                    const timeStr = response.data.website_start.time; // "16:23:30"
                    // Create ISO string: "2025-06-21T16:23:30"
                    const isoString = `${dateStr}T${timeStr}`;
                    this.time = new Date(isoString);
                })
                .catch((error) => {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.response.data.message,
                    });
                });
        }
    },
    mounted() {
        this.fetchWebTime();
    }
}
</script>